import { render, staticRenderFns } from "./UpdateWHProduct.vue?vue&type=template&id=1a3318cb&"
import script from "./UpdateWHProduct.vue?vue&type=script&lang=js&"
export * from "./UpdateWHProduct.vue?vue&type=script&lang=js&"
import style0 from "./UpdateWHProduct.vue?vue&type=style&index=0&id=1a3318cb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports